const slides = document.getElementsByClassName('cm-splide');
const splideInstances = [];

// 要素が存在する場合のみ初期化
if (slides.length > 0) {
  Array.from(slides).forEach((slide) => {
    const slideItems = slide.querySelectorAll('.splide__slide');
    const hasMultipleSlides = slideItems.length > 1;

    if (hasMultipleSlides) {
      const autoplay = slide.dataset.autoplay === 'true';
      const interval = (parseInt(slide.dataset.interval) || 3) * 1000;
      const speed = (parseInt(slide.dataset.speed) || 3) * 1000;

      const splide = new Splide(slide, {
        type: 'loop',
        perPage: 1,
        autoplay,
        interval,
        speed,
        easing: 'ease',
        arrows: true,
        pagination: true,
        rewind: true,
        breakpoints: {
          767: {
            arrows: false,
          },
        },
      });

      splide.mount();
      splideInstances.push(splide);
    } else {
      slide.style.visibility = 'visible';
    }

    /* if (!hasMultipleSlides) {
      const playBtn = slide.querySelector('.play_btn');
      if (playBtn) {
        playBtn.style.display = 'none';
      }
    } */
  });

  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      splideInstances.forEach((splide) => {
        splide.refresh();
      });
    }, 200);
  });
}
